<ng-container *ngIf="contentReady; else certificateLoading">
<h1 class="title">{{ pageTitle }}</h1>
<div class="change-email-toast">
  <ng-ui-kit-toast
    *ngIf="showEmailChangeSuccess"
    status="success"
    [text]="
      'CERT_PAGE.CHANGE_EMAIL.SUCCESSFUL_EMAIL_CHANGE_BANNER' | translate
    ">
  </ng-ui-kit-toast>
</div>
<app-page-wrapper>
  <ng-ui-kit-data-module
    *ngIf="certificate.active && !isExpiring"
    icId="data-module-success-id"
    [label]="
      'COMMON.TOOLTIP_CERT'
        | translate
          : {
              state: (certStateMessage | translate),
              expirationDate: expirationDate,
            }
    "
    status="success">
  </ng-ui-kit-data-module>
  <ng-ui-kit-data-module
    *ngIf="!certificate.active && !isExpiring"
    icId="data-module-danger-id"
    [label]="
      'COMMON.TOOLTIP_CERT'
        | translate
          : {
              state: (certStateMessage | translate),
              expirationDate: expirationDate,
            }
    "
    status="danger">
  </ng-ui-kit-data-module>
  <ng-ui-kit-data-module
    *ngIf="isExpiring"
    icId="data-module-warning-id"
    [label]="
      'COMMON.TOOLTIP_CERT'
        | translate
          : {
              state: (certStateMessage | translate),
              expirationDate: expirationDate,
            }
    "
    status="warning">
  </ng-ui-kit-data-module>
  <br />
  <ng-ui-kit-card
    type="summative"
    [title]="'CERT_PAGE.DETAILS.TITLE' | translate"
    [text]="'CERT_PAGE.DETAILS.DESC' | translate"
    className="type-1"
    [attr.translate-key]="'CERT_PAGE.DETAILS.TITLE'"
    [data]="true"
    [attr.translate-key]="'CERT_PAGE.DETAILS.TITLE,CERT_PAGE.DETAILS.DESC'">
    <ng-container data>
      <div class="button-container full-btns-mobile">
        <ng-ui-kit-dropdown
          [items]="dropdownItems$ | async"
          [open]="isDropdownOpen"
          (toggle)="toggleDropdown()"
          (onChange)="onSelectDropdown($event.value)"
          [attr.aria-label]="'CERT_PAGE.DOWNLOAD_CERT' | translate"
          [attr.aria-describedby]="'download-format-description'"
          [icRole]="'menu'">
          <ng-ui-kit-button
            dropdownToggle
            className="btn-full-mobile btn-download download-certificate"
            [stopPropagation]="false"
            color="tertiary"
            size="sm"
            iconBefore="file_download"
            [iconAfter]="isDropdownOpen ? 'arrow_drop_up' : 'arrow_drop_down'"
            [attr.downloadUrl]="downloadUrl"
            [label]="'CERT_PAGE.DOWNLOAD_CERT' | translate"
            [attr.aria-expanded]="isDropdownOpen"
            [attr.aria-haspopup]="'menu'">
          </ng-ui-kit-button>
        </ng-ui-kit-dropdown>
        <div
          id="download-format-description"
          class="sr-only"
          [attr.translate-key]="'CERT_PAGE.SELECT_FORMAT'">
          {{ 'CERT_PAGE.SELECT_FORMAT' | translate }}
        </div>
      </div>
      <ng-ui-kit-separator></ng-ui-kit-separator>

      <div class="ic1-row">
        <div class="ic1-col-12">
          <h2 class="cert-title" translate>
            CERT_PAGE.DETAILS.HOLDER
          </h2>
        </div>

        <ng-container
          *ngFor="
            let item of subjectDN | keyvalue: asIsOrder;
            last as isLast;
            first as isFirst
          ">
          <div
            *ngIf="item.value && item.key !== 'value' && !subjectDnMap"
            class="ic1-col-md-6 ic1-col-12 cert-details"
            [ngClass]="{ 'last-child': isLast, 'first-child': isFirst }">
            <div>
              <div
                class="ic1-text-label-1"
                translate="CERT_PAGE.LABEL.{{ item.key | uppercase }}"></div>

              <div class="ic1-text-body-2">
                {{ item.value }}
              </div>
            </div>
          </div>
          <ng-ui-kit-separator *ngIf="!isLast"></ng-ui-kit-separator>
        </ng-container>

        <ng-container
          *ngFor="
            let item of subjectDnMap | keyvalue: asIsOrder;
            last as isLast;
            first as isFirst
          ">
          <div
            *ngIf="item.value && item.key !== 'value'"
            class="ic1-col-md-6 ic1-col-12 cert-details"
            [ngClass]="{ 'last-child': isLast, 'first-child': isFirst }">
            <div>
              <div
                class="ic1-text-label-1"
                [translate]="getTranslationKey(item.key)"></div>

              <div class="ic1-text-body-2">
                {{ item.value }}
              </div>
            </div>
          </div>
          <ng-ui-kit-separator *ngIf="!isLast"></ng-ui-kit-separator>
        </ng-container>

        <ng-ui-kit-separator *ngIf="certificateId"></ng-ui-kit-separator>
        <div
          *ngIf="certificateId"
          class="ic1-col-md-6 ic1-col-12 cert-details">
          <div>
            <div
              class="ic1-text-label-1"
              translate="CERT_PAGE.LABEL.CERTIFICATE_ID"></div>

            <div class="ic1-text-body-2">
              {{ certificateId }}
            </div>
          </div>
        </div>

        <ng-ui-kit-separator
          *ngIf="aliasCertificate || domain"></ng-ui-kit-separator>
        <div
          *ngIf="aliasCertificate"
          class="ic1-col-md-6 ic1-col-12 cert-details">
          <div>
            <div
              class="ic1-text-label-1"
              translate="CERT_PAGE.LABEL.ALIAS_CERTIFICATE"></div>

            <div class="ic1-text-body-2">
              {{ aliasCertificate }}
            </div>
          </div>
        </div>
        <ng-ui-kit-separator *ngIf="aliasCertificate"></ng-ui-kit-separator>
        <div *ngIf="domain" class="ic1-col-md-6 ic1-col-12 cert-details">
          <div>
            <div
              class="ic1-text-label-1"
              translate="CERT_PAGE.LABEL.DOMAIN"></div>

            <div class="ic1-text-body-2">
              {{ domain }}
            </div>
          </div>
        </div>

        <div class="ic1-col-12 ic1-my-24">
          <ng-ui-kit-separator></ng-ui-kit-separator>
        </div>
        <div class="ic1-col-12">
          <h2 class="cert-title" translate>
            CERT_PAGE.DETAILS.AUTHORITY
          </h2>
        </div>

        <ng-container
          *ngFor="
            let item of issuerDN | keyvalue: asIsOrder;
            last as isLast;
            first as isFirst
          ">
          <div
            *ngIf="item.value"
            class="ic1-col-md-6 ic1-col-12 cert-details"
            [ngClass]="{ 'last-child': isLast, 'first-child': isFirst }">
            <div>
              <div
                class="ic1-text-label-1"
                translate="CERT_PAGE.LABEL.{{ item.key }}"></div>

              <div class="ic1-text-body-2">
                {{ item.value }}
              </div>
            </div>
          </div>
          <ng-ui-kit-separator *ngIf="!isLast"></ng-ui-kit-separator>
        </ng-container>
      </div>
    </ng-container>
  </ng-ui-kit-card>
</app-page-wrapper>
<br />
<app-page-wrapper>
  <ng-ui-kit-card
    type="summative"
    [title]="'CERT_PAGE.CHANGE_EMAIL.CONTACT_DETAILS' | translate"
    className="type-1"
    [attr.translate-key]="'CERT_PAGE.CHANGE_EMAIL.CONTACT_DETAILS'"
    [data]="true">
    <ng-container data>
        <button
          id="open-change-email-modal"
          type="button"
          class="change-email"
          translate
          (click)="openModal()">
          COMMON.BUTTON.CHANGE
        </button>

      <ng-ui-kit-separator></ng-ui-kit-separator>

      <div class="ic1-row">
        <ng-container>
          <div class="ic1-col-md-6 ic1-col-12 cert-details">
            <div>
              <div
                class="ic1-text-label-1"
                translate="CERT_PAGE.CHANGE_EMAIL.EMAIL_ADDRESS"></div>

              <div class="ic1-text-body-2">
                {{ email }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-ui-kit-card>
</app-page-wrapper>
<app-common-modal
  modalId="change-email-modal"
  [title]="'CERT_PAGE.CHANGE_EMAIL.CHANGE_CONTACT_DETAILS' | translate"
  [(visible)]="changeEmailModalVisible"
  [config]="{ size: 'lg', hideButtons: true, autoFocusTarget: 'first-tabbable' }"
  (onClose)="onToggleChangeEmailModal(false)">
  <form [formGroup]="emailForm" class="emailForm">
    <div class="ic1-row">
      <div class="ic1-col-12 ic1-col-lg-6">
        <div class="ic1-form-group">
          <ng-ui-kit-input
            formControlName="emailField"
            name="emailField"
            autocomplete="emailField"
            autocomplete="emailField"
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
            [placeholder]="email"
            type="text"
            icName="emailField"
            icId="emailField"
            [label]="'CERT_PAGE.CHANGE_EMAIL.EMAIL_ADDRESS' | translate"
            [status]="
              changeEmailAttempted && emailField.invalid
                ? 'error'
                : 'informative'
            ">
          </ng-ui-kit-input>
        </div>
        <app-field-validator
          *ngIf="changeEmailAttempted"
          [field]="emailField"
          [formErrors]="emailFormErrors"></app-field-validator>
      </div>

      <div class="ic1-col-12 ic1-col-lg-6">
        <div class="ic1-form-group">
          <app-otp-input
            formControlName="otp"
            [error]="changeEmailAttempted && otp.invalid"
            [startTimer]="changeEmailModalVisible"></app-otp-input>
        </div>
        <app-field-validator
          *ngIf="changeEmailAttempted"
          [field]="otp"
          [formErrors]="emailFormErrors"></app-field-validator>
      </div>
    </div>

    <div class="buttons-container">
      <ng-ui-kit-button
        color="secondary"
        [label]="'COMMON.BUTTON.CANCEL' | translate"
        type="button"
        size="sm"
        (onClick)="closeModal()">
      </ng-ui-kit-button>

      <app-submit-button
        type="submit"
        [label]="'COMMON.BUTTON.SAVE' | translate"
        translate-key="COMMON.BUTTON.SAVE"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="onChangeEmail()">
      </app-submit-button>
    </div>
  </form>
</app-common-modal>
</ng-container>

<ng-template #certificateLoading>
  <div class="cert-loading">
    <ng-ui-kit-spinner size="lg"></ng-ui-kit-spinner>
  </div>
</ng-template>
